import Api from '@/api';
import ArgumentError from '@/exceptions/argument-error';

const lookupEmail = (context, data) => new Promise((resolve, reject) => {
  Api.personService.checkEmail(data.email, data.type)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

const makeAccount = (context, accountData) => new Promise((resolve, reject) => {
  Api.personService.createAccount(accountData)
    .then(response => {
      context.commit('setAccount', response.data);
      resolve(response.data);
    })
    .catch(error => reject(error.data));
});

const loadRep = (context, repId) => new Promise((resolve, reject) => {
  if (!repId) {
    return reject(new ArgumentError('Rep Id is required').message);
  }

  return Api.personService.getRep(repId)
    .then(response => {
      context.commit('setRep', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setRep', {});
      reject(error.data);
    });
});

const loadCustomer = (context, customerId) => new Promise((resolve, reject) => {
  if (!customerId) {
    return reject(new ArgumentError('Customer Id is required').message);
  }

  return Api.personService.getCustomer(customerId)
    .then(response => {
      context.commit('setCustomer', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setCustomer', {});
      reject(error.data);
    });
});

const loadInspector = (context, inspectorId) => new Promise((resolve, reject) => {
  if (!inspectorId) {
    return reject(new ArgumentError('Inspector Id is required').message);
  }

  return Api.personService.getInspector(inspectorId)
    .then(response => {
      context.commit('setInspector', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setInspector', {});
      reject(error.data);
    });
});

const loadPerson = (context, person) => new Promise((resolve, reject) => {
  Api.personService.getPerson(person.id, person.type)
    .then(response => {
      context.commit('setPerson', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setPerson', {});
      reject(error.data);
    });
});

const findCustomer = (context, customerEmail) => new Promise((resolve, reject) => {
  if (!customerEmail) {
    return reject(new ArgumentError('Customer Email is required').message);
  }

  return Api.personService.searchCustomer(customerEmail)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

const findRep = (context, repEmail) => new Promise((resolve, reject) => {
  if (!repEmail) {
    return reject(new ArgumentError('Rep Email is required').message);
  }

  return Api.personService.searchRep(repEmail)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

const patchPerson = (context, person) => new Promise((resolve, reject) => {
  if (!person) {
    return reject(new ArgumentError('Person data is required'));
  }

  if (!person.personId) {
    return reject(new ArgumentError('PersonId is required'));
  }

  return Api.personService.patchPerson(person)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

export default {
  lookupEmail,
  makeAccount,
  loadRep,
  loadCustomer,
  loadInspector,
  loadPerson,
  findCustomer,
  findRep,
  patchPerson,
};
